import * as React from "react";
import * as ReactTooltip from "react-tooltip";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import * as moment from "moment";
// BO COMPONENTS
import BOText from "app/components/BOComponents/BOText/BOText";

import Dialog from "material-ui/Dialog";
import { Tooltip, Button } from "@material-ui/core";
class Payments extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: [],
      loading: false,
      open: false,
      log_data: ""
    };

    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    this.props.setBreadCrumbs([
      { title: "SnapScan Ops" },
      { title: "Payments", link: "/snapscan/ops/payments" },
      { title: this.props.match.params.id, class: "crumbOverflow" },
      { title: "Pay Requests" }
    ]);
    this.loadData();
  }

  closeModal() {
    this.setState({ open: false, log_data: "" });
  }

  openModal(data: any) {
    this.setState({ open: true, log_data: data });
  }

  loadData() {
    this.setState({ data: [], loading: true });

    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: fetchMoreResult.payments[0],
          loading: false
        });
        let time = moment(fetchMoreResult.payments[0].created_at);
        let weekTest = moment()
          .subtract(7, "days")
          .startOf("day")
          .isAfter(time);

        this.props.setHeader({
          title: "Ops > Payment",
          description: `${
            weekTest
              ? moment(fetchMoreResult.payments[0].created_at).calendar()
              : moment(fetchMoreResult.payments[0].created_at).fromNow()
          } - ${fetchMoreResult.payments[0].merchant.name}`
        });
      }
    });
  }

  render() {
    const payment = this.state.data ? this.state.data : {};

    // Format Date
    const formatDate = date => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  STATUS FORMATING
    const formatStatusColour = status => {
      if (status === "completed") {
        return "#ebffeb";
      } else if (status === "pending") {
        return "white";
      } else if (status === "error") {
        return "#ffebeb";
      } else {
        return "white";
      }
    };

    //  CHECK LIST
    const checkList = () => {
      if (payment && Object.keys(payment).length > 0) {
        if (payment.payserv_payment) {
          return payment.payserv_payment.payserv_requests.map((val, key) => {
            const log = () => {
              if (val.log) {
                return (
                  <Tooltip title="Log">
                    <Button onClick={() => this.openModal(val.log)}>
                      <i className="fa fa-file-text" />
                    </Button>
                  </Tooltip>
                );
              } else {
                return null;
              }
            };
            return (
              <tr
                key={key}
                style={{ backgroundColor: formatStatusColour(val.status) }}
              >
                <td> {formatDate(val.created_at)}</td>
                <td> {val.request_type}</td>
                <td> {val.psp}</td>
                <td> {val.bank_response_code}</td>
                <td> {val.duration}</td>
                <td> {val.http_status_code}</td>
                <td>
                  {log()}
                  <ReactTooltip effect="solid" />
                </td>
              </tr>
            );
          });
        } else {
          return (
            <tr>
              <td style={{ textAlign: "center" }} colSpan={8}>
                <i
                  style={{ marginRight: "8px" }}
                  className="fa fa-exclamation-triangle"
                />
                Payserv not available
              </td>
            </tr>
          );
        }
      }
    };

    const modalLog = logData => {
      const convertedData = () => {
        // var data  = JSON.parse(log_data);
        return logData;
      };
      return (
        <pre
          style={{
            outline: "1px solid #ccc",
            padding: "5px",
            margin: "5px",
            whiteSpace: "pre-wrap",
            fontSize: "12px"
          }}
        >
          {convertedData()}
        </pre>
      );
    };

    return (
      <section id="Fraud_TopDevices">
        <div className="DetailTopBar">
          <BOText
            text="Summary"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/summary`}
            active="selected"
          />
          <BOText
            text="Details"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/details`}
            active="selected"
          />
          <BOText
            text="Pay"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay`}
            active="selected"
          />
          <BOText
            text="Pay requests"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay_requests`}
            active="selected"
          />
        </div>

        <section className="padded">
          <div
            className={`loader-container ${
              this.state.loading ? "shown" : "hidden"
            }`}
          >
            <i className={`fa fa-spinner fa-spin fa-5x fa-fw`} />
          </div>

          <div
            id="setHeight"
            style={{ height: "calc(100% - 80px)", overflow: "auto" }}
          >
            <table
              style={{
                width: "100%"
              }}
              className={`BOTable`}
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Request Type</th>
                  <th>PSP</th>
                  <th>Bank response code</th>
                  <th>Duration(miliseconds)</th>
                  <th>Http status code</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className={`${this.state.loading ? "hidden" : "shown"} `}>
                {checkList()}
              </tbody>
            </table>
          </div>

          <Dialog
            title="Log"
            modal={false}
            open={this.state.open}
            onRequestClose={this.closeModal}
            actions={[
              <input
                type="button"
                className="button"
                value="Close"
                onClick={this.closeModal}
              />
            ]}
            autoScrollBodyContent={true}
          >
            {modalLog(this.state.log_data)}
          </Dialog>
        </section>
      </section>
    );
  }
}

const UserPayments = gql`
  query Currentlist($reference: String) {
    payments(reference: $reference) {
      created_at
      merchant {
        name
      }
      payserv_payment {
        payserv_requests {
          bank_response_code
          created_at
          duration
          error_message
          error_reason
          external_reference
          http_status_code
          log
          psp
          request_type
          status
          updated_at
        }
      }
    }
  }
`;

const paymentPayRequestsWithGraphql = graphql(UserPayments, {
  options(props: any) {
    return {
      variables: {
        reference: props.match.params.id
      }
    };
  }
})(Payments);
export default paymentPayRequestsWithGraphql;
